// Tính toán with, height của PhotoItem
export default function calculateSize(selector, minWidth = 140) {
	const el = document.querySelector(selector);
	
	if (!el) {
		return {
			width: 0,
			height: 0,
			col: 0,
			row: 0
		};
	}

	const pP = el.getBoundingClientRect();
	const cs = window.getComputedStyle(el);
	const pW = pP.width - (
		parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight)
		+ parseFloat(cs.borderRightWidth) + parseFloat(cs.borderLeftWidth)
	);
	const pH = pP.height - (
		parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)
		+ parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)
	);

	function cal(col) {
		const iW = pW / col;
		const niW = pW / (col + 1);

		if (niW > minWidth) {
			return cal(col + 1);
		} else {
			return {
				col,
				iW
			};
		}
	}

	const size = cal(1);
	const row = Math.ceil(pH / size.iW);

	return {
		width: size.iW,
		height: pH / row,
		col: size.col,
		row
	};
}